import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Layout, Modal } from 'antd';
import { withTranslation } from 'react-i18next';
import { IsSearchMenu } from '../../utils/read-querystring-helper';

import HeaderPage from '../../components/Guest/Header/headerMain';
import OrderPage from '../Order/order';
import FooterMenu from '../../components/Guest/Footer/Footer';
import OrderDetailModal from '../Order/orderDetailModal';

const { Content } = Layout;

@inject(
    'translationStore',
    'loginStore',
    'authStore',
    'TransactionStore'
)
@observer
class MasterOrderPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        const roomNo = this.props.loginStore.getRoomNo();
        if (!roomNo) {
            this.props.history.push('/login')
        }

        this.props.loginStore.authenticateGuest().then(response => {
            if (!response) {
                this.props.history.push('/login');
            }
        });
    }

    render() {
        const history = this.props.history;
        const isSearchMenu = IsSearchMenu(this);

        const {
            showOrderDetailModal
        } = this.props.TransactionStore;

        return (
            <Layout className='stm-layout-master'>
                <Modal
                    className='stm-modal'
                    title='Order Detail'
                    onCancel={() => { this.props.TransactionStore.setshowOrderDetailModal(false) }}
                    visible={showOrderDetailModal}
                >
                    <OrderDetailModal />
                </Modal>

                <Content>
                    {!isSearchMenu ? (<HeaderPage history={history} />) : <React.Fragment></React.Fragment>}

                    <OrderPage history={history} />

                    {!isSearchMenu ? (<FooterMenu history={history} menuText={'order'} />) : <React.Fragment></React.Fragment>}
                </Content>
            </Layout>
        )
    }
}

export default withTranslation()(MasterOrderPage)